import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import RasasAPI from '../../api/rasas';
import SmartsAPI from '../../api/smart';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
  smarts: [],
};

export const getters = {
  getRasa(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getSmart(_state) {
    return _state.smarts;
  },
  getOne:
    $state =>
    ({ inboxId, rasas_type = 'robot' }) => {
      const [rasa] = $state.records.filter(
        record =>
          record.inbox_id === Number(inboxId) &&
          record.rasas_type === rasas_type
      );
      return rasa || {};
    },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_RASA_UI_FLAG, { isFetching: true });
    try {
      const response = await RasasAPI.get();
      commit(types.default.SET_RASA, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.default.SET_RASA_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, cannedObj) => {
    commit(types.default.SET_RASA_UI_FLAG, { isCreating: true });
    try {
      const response = await RasasAPI.create(cannedObj);
      commit(types.default.ADD_RASA, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_RASA_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.default.SET_RASA_UI_FLAG, { isUpdating: true });
    try {
      if (id) {
        const response = await RasasAPI.update(id, updateObj);
        commit(types.default.UPDATE_RASA, response.data);
      } else {
        const response = await RasasAPI.create(updateObj);
        commit(types.default.ADD_RASA, response.data);
      }
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_RASA_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.default.SET_RASA_UI_FLAG, { isDeleting: true });
    try {
      await RasasAPI.delete(id);
      commit(types.default.DELETE_RASA, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_RASA_UI_FLAG, { isDeleting: false });
    }
  },

  setSmart: async ({ commit }, search) => {
    try {
      const response = await SmartsAPI.get(search);
      state.smarts = response.data;
    } catch (error) {
      // Handle error
    }
  },
};

export const mutations = {
  [types.default.SET_RASA_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_RASA]: MutationHelpers.set,
  [types.default.ADD_RASA]: MutationHelpers.create,
  [types.default.UPDATE_RASA]: MutationHelpers.update,
  [types.default.DELETE_RASA]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
